import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./quotation.css";
import { X } from "lucide-react"; 

const QuotationForm = () => {
  const location = useLocation();
  const product = location.state?.product; 
  const [formData, setFormData] = useState({ name: "", mail: "", query: "" });
  const [message, setMessage] = useState(null); 
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!config) return;

    const payload = {
      ...formData,
      product_id: product?.product_id || null
    };

    try {
      const response = await fetch(`${config.BASE_URL}${config.SAVE_QUOTATION}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.success) {
        setMessage({ type: "success", text: "Query submitted successfully!" });
        setFormData({ name: "", mail: "", query: "" });
      } else {
        setMessage({ type: "error", text: result.message || "Failed to submit query" });
      }
    } catch (error) {
      setMessage({ type: "error", text: "Something went wrong!" });
    }
  };

  // Auto-hide floating message
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div className="cf-page">
      {message && (
        <div className={`floating-message ${message.type}`}>
          <span>{message.text}</span>
          <X size={18} style={{ marginLeft: "15px", cursor: "pointer" }} onClick={() => setMessage(null)} />
        </div>
      )}

      <div className="cf-container">
        <div className="cf-side">
          <div className="cf-side-header">
            <h1>&#9135;&#9135;&#9135;&#9135;&nbsp;&nbsp;CONTACT US</h1>
          </div>
          <div className="cf-social">
            <ul>
              <li><i className="fab fa-facebook-f"></i></li>
              <li><i className="fab fa-twitter"></i></li>
              <li><i className="fab fa-instagram"></i></li>
              <li><i className="fab fa-whatsapp"></i></li>
            </ul>
          </div>
        </div>

        <div className="cf-header">
          <h1>Let's Get Started</h1>
          <h2>Contact us to Clear Your Query!</h2>
        </div>

        <div className="cf-address">
          <i className="fas fa-map-marker-alt"></i>
          <h3>MVP Colony</h3>
          <h3>Sector 12, Visakhapatnam</h3>
        </div>

        <div className="cf-phone">
          <i className="fas fa-phone-alt"></i>
          <h3>+91 8142678901</h3>
        </div>

        <div className="cf-email">
          <i className="fas fa-envelope"></i>
          <h3>info@robocoupler.com</h3>
        </div>
        
        <div className="cf-form">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="mail"
              placeholder="Email"
              value={formData.mail}
              onChange={handleChange}
              required
            />
            <textarea
              name="query"
              rows="4"
              placeholder="Write Your Query"
              value={formData.query}
              onChange={handleChange}
              required
            ></textarea>

            {/* Optionally show product name */}
            {product && <p className="selected-product">Product: {product.title}</p>}

            <button type="submit">SEND</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default QuotationForm;
